import { Injectable } from '@angular/core';
import {
    CartesianTile,
    GeoBounds,
} from '@polaris-customerweb/sharedcomponents.shared';

@Injectable({ providedIn: 'root' })
export class GeoBoundsTileService {
    getTiles(bounds: GeoBounds): CartesianTile[] {
        const upperLeftTile = CartesianTile.fromGeoCoordinate(bounds.northWest);
        const lowerRightTile = CartesianTile.fromGeoCoordinate(
            bounds.southEast
        );

        // get all tiles between (and including) upper left and lower right
        const tiles: CartesianTile[] = [];
        for (
            let col = upperLeftTile.column, endCol = lowerRightTile.column;
            col <= endCol;
            col++
        ) {
            for (
                let row = upperLeftTile.row, endRow = lowerRightTile.row;
                row <= endRow;
                row++
            ) {
                tiles.push(new CartesianTile(col, row));
            }
        }

        return tiles;
    }
}
